import styled from 'styled-components';

export default {
    StyledLoader: styled.svg.attrs({ className: 'styled-loader' })`
      & .fill {
        transform-origin: 50% 50%;
        fill: #E50000;
        animation: rotate 1s linear infinite;
      }
      @keyframes rotate {
        100% {
          transform: rotate(360deg);
        }
      } 
    `,
    Modal: styled.div.attrs({ className: 'modal' })`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100%;
        background: rgba(255,255,255, 0.6);
        z-index: 101;
        overflow-y: auto;
    `,
    LoaderBlock: styled.div`
     padding-top: 20%;
     width: 200px;
     height: 200px;
     margin: 0 auto;
`,
    LoaderContainer: styled.div.attrs({ className: 'loader-container' })`
     width: 100%;
     background: rgba(0, 0, 0, 0);
     height: 100%;
`,
};
